const mapStateToProps = state => ({
    isUser: state.authToken === '' ? false : true,
    deviceIsOnline: state.deviceIsOnline,
    isAdmin: state.isAdmin,
    authToken: state.authToken,
    unseenNoticeCount: state.unseenNoticeCount,
    showFullMenu: state.showFullMenu,
    clientSettings: state.clientSettings,
    customView: state.customView
});

export default mapStateToProps;